/**
 * CommunicationsUnifiedPage - Consolidates Correspondence, Announcements, Emergency Alerts, and Comms Hub
 */
import { useState } from "react";
import { useAuth } from "../App";
import AdminSidebar from "../components/layout/AdminSidebar";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Mail, Megaphone, AlertTriangle, FileEdit } from "lucide-react";

// Lazy imports of existing page content - we strip their sidebar wrappers
import CorrespondencePage from "./CorrespondencePage";
import AnnouncementsPage from "./AnnouncementsPage";
import EmergencyAlertsPage from "./EmergencyAlertsPage";
import CommunicationsHubPage from "./CommunicationsHubPage";

const CommunicationsUnifiedPage = () => {
  const [activeTab, setActiveTab] = useState("correspondence");

  return (
    <div data-testid="communications-unified-page" className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold font-serif">Communications</h1>
        <p className="text-muted-foreground">All messaging, announcements, and alerts in one place</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="mb-4">
          <TabsTrigger value="correspondence" data-testid="tab-correspondence" className="gap-2">
            <Mail className="w-4 h-4" /> Messages
          </TabsTrigger>
          <TabsTrigger value="announcements" data-testid="tab-announcements" className="gap-2">
            <Megaphone className="w-4 h-4" /> Announcements
          </TabsTrigger>
          <TabsTrigger value="emergency" data-testid="tab-emergency" className="gap-2">
            <AlertTriangle className="w-4 h-4" /> Emergency
          </TabsTrigger>
          <TabsTrigger value="hub" data-testid="tab-hub" className="gap-2">
            <FileEdit className="w-4 h-4" /> Draft & Send
          </TabsTrigger>
        </TabsList>

        <TabsContent value="correspondence">
          <CorrespondenceInner />
        </TabsContent>
        <TabsContent value="announcements">
          <AnnouncementsInner />
        </TabsContent>
        <TabsContent value="emergency">
          <EmergencyInner />
        </TabsContent>
        <TabsContent value="hub">
          <HubInner />
        </TabsContent>
      </Tabs>
    </div>
  );
};

// Inner wrappers that strip the sidebar from each page
const CorrespondenceInner = () => <div data-testid="correspondence-content"><CorrespondencePage embedded /></div>;
const AnnouncementsInner = () => <div data-testid="announcements-content"><AnnouncementsPage embedded /></div>;
const EmergencyInner = () => <div data-testid="emergency-content"><EmergencyAlertsPage embedded /></div>;
const HubInner = () => <div data-testid="hub-content"><CommunicationsHubPage embedded /></div>;

export default CommunicationsUnifiedPage;
